import React, { useState, useEffect, useRef } from 'react';

interface CountdownTimerProps {
  initialSeconds: number;
  onExpire?: () => void;
  format?: 'MM:SS' | 'SS';
  asText?: boolean;
}

export function CountdownTimer({
  initialSeconds,
  onExpire,
  format = 'MM:SS',
  asText = false,
}: CountdownTimerProps) {
  const [seconds, setSeconds] = useState(initialSeconds);
  const onExpireRef = useRef(onExpire);

  useEffect(() => {
    onExpireRef.current = onExpire;
  }, [onExpire]);

  useEffect(() => {
    setSeconds(initialSeconds);
  }, [initialSeconds]);

  useEffect(() => {
    if (seconds <= 0) {
      if (onExpireRef.current) {
        onExpireRef.current();
      }
      return;
    }

    const timer = setInterval(() => {
      setSeconds((prev) => {
        if (prev <= 1) {
          if (onExpireRef.current) {
            onExpireRef.current();
          }
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    // eslint-disable-next-line consistent-return
    return () => clearInterval(timer);
  }, [seconds]);

  const formatTime = () => {
    if (format === 'SS') {
      return `${seconds}s`;
    }

    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  if (asText) {
    return <>{formatTime()}</>;
  }

  return (
    <span
      style={{
        fontFamily: 'Inter',
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '24px',
        color: seconds <= 60 ? '#AB2135' : '#1E202C',
      }}
    >
      {formatTime()}
    </span>
  );
}
